export const EMAIL_VERIFICATINO_VERIFY_EMAIL_REQUEST = 'EMAIL-VERIFICATION/VERIFY-EMAIL/REQUESTED';
export const EMAIL_VERIFICATINO_VERIFY_EMAIL_RECEIVED = 'EMAIL-VERIFICATION/VERIFY-EMAIL/RECEIVED';

export const EMAIL_VERIFICATINO_FAILED = 'EMAIL-VERIFICATION/FAILED';
